<template>
  <div>
    <!-- 产品增加 -->
    <el-dialog :title="operate === 'edit' ? '编辑产品' : '添加产品'" :close-on-click-modal="false" :visible="visible"
      class="imgbox" width="1100px" :append-to-body="true" :before-close="closeDialog" @close="close">
        <addProductDialogStep1 ref="addProductDialogStep1" :productDetail="addProductDetail" :operate="operate" :currentStep="currentStep" /> 
        <addProductDialogStep2 ref="addProductDialogStep2" :expandDto="addProductDetail.expandDto" :currentStep="currentStep" :operate="operate" />
        <addProductDialogStep3 ref="addProductDialogStep3" :expandDto="addProductDetail.expandDto" :currentStep="currentStep" />
        <addProductDialogStep4 ref="addProductDialogStep4" @closeDialog="submitFinish" :productDetail="addProductDetail" :currentStep="currentStep" @delImg="delImg"/>

        <div style="text-align: center;">
          <el-button type="primary" @click="submitProduct">新增</el-button>
        </div>
      <!-- 

      

      <addProductDialogStep4 :productDetail="addProductDetail" :currentStep="currentStep" v-show="currentStep === 4"
        @prevStep="prevStep" @delImg="delImg" @nextStep="nextStep" @closeDialog="closeDialog" /> -->




      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="nextStep">下一步</el-button>
      </div> -->


    </el-dialog>
    <!-- <ChooseTypeDrawe v-if="drawerFlag" :drawerFlag="drawerFlag" @closeDrawer="closeDrawer" @getData="receive" /> -->
  </div>
</template>
<script>
import ChooseTypeDrawe from '@/components/product_control/chooseTypeDrawe'
import eventBus from '@/assets/js/eventBus'

import addProductDialogStep1 from '@/components/product_control/addProductDialogStep1'
import addProductDialogStep2 from '@/components/product_control/addProductDialogStep2'
import addProductDialogStep3 from '@/components/product_control/addProductDialogStep3'
import addProductDialogStep4 from '@/components/product_control/addProductDialogStep4'
export default {
  props: {
    operate: {
      type: String
    },
    currentStep: {
      type: Number
    },
    addProductDetail: {
      type: Object
    },
    visible: {
      type: Boolean
    }
  },
  components: {
    ChooseTypeDrawe
  },
  data() {
    const inputFocus = (rule, value, callback) => {
      if (this.form.categoryParentId === '' && this.form.categoryId === '') {
        callback(new Error('请选择产品品类'))
      } else {
        callback()
      }
    }
    const inputProductKey = (rule, value, callback) => {
      const reg = /^[A-Za-z0-9]+$/
      if (this.tag === 1) {
        if (this.form.productKey === '') {
          callback(new Error('产品标识不能为空'))
        } else if (this.form.productKey.length < 11) {
          callback(new Error('产品标识字符长度不得小于11'))
        } else if (this.form.productKey.length > 32) {
          callback(new Error('产品标识字符长度不得超过32个'))
        } else if (!reg.test(this.form.productKey)) {
          callback(new Error('产品标识只能由大小写字母，数字组成'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      tag: 0,
      categoryName: '',
      form: {
        productName: '', // 产品名称
        productKey: '', // 产品标识
        productModelType: 0, // 产品品类
        categoryParentId: '', // 父级ID
        categoryId: '', // 子品类id
        nodeType: '', // 节点类型
        connectionType: '', // 连网方式
        dataFormat: '', // 数据格式
        authType: '', // 认证方式
        isPrivate: 0, // 认证是否私有
        productDescription: '' // 描述
      },
      rules: {
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ],
        productModelType: [
          { required: true, message: '请选择产品物模型类型', trigger: 'change' }
        ],
        category: [
          { required: true, validator: inputFocus, trigger: 'change' }
        ],
        productKey: [
          { validator: inputProductKey, trigger: 'blur' }
        ],
        nodeType: [
          { required: true, message: '请选择节点类型', trigger: 'change' }
        ],
        connectionType: [
          { required: true, message: '请选择连网方式', trigger: 'change' }
        ],
        dataFormat: [
          { required: true, message: '请选择数据格式', trigger: 'change' }
        ],
        authType: [
          { required: true, message: '请选择认证方式', trigger: 'change' }
        ],
        isPrivate: [
          { required: true, message: '认证是否私有', trigger: 'change' }
        ]
      },
      focusStatus: true,
      autosize: { minRows: 6 }, // 设置textarea的最小高度
      nodeTypeOptions: [
        {
          nodeTypeName: '直连设备',
          nodeTypeKey: 0
        },
        {
          nodeTypeName: '网关子设备',
          nodeTypeKey: 1
        },
        {
          nodeTypeName: '网关设备',
          nodeTypeKey: 2
        }
      ],
      connectionTypeOptions: [
        {
          connectionTypeName: 'Wi-Fi',
          connectionTypeKey: 1
        },
        {
          connectionTypeName: 'Zigbee',
          connectionTypeKey: 2
        },
        {
          connectionTypeName: '蓝牙',
          connectionTypeKey: 3
        },
        {
          connectionTypeName: '蜂窝网(2G/3G/4G/5G)', // 蜂窝网ETHERNET
          connectionTypeKey: '4'
        },
        {
          connectionTypeName: '以太网',
          connectionTypeKey: '5'
        },
        {
          connectionTypeName: 'LiRaWAN',
          connectionTypeKey: '6'
        },
        {
          connectionTypeName: '其他',
          connectionTypeKey: '7'
        }
      ],
      dataFormatOptions: [
        {
          dataFormatName: 'ICA标准数据格式(Alink JSON)',
          dataFormatKey: 0
        },
        {
          dataFormatName: '透传/自定义',
          dataFormatKey: 1
        }
      ],
      authTypeOptions: [
        {
          authTypeName: '设备密钥',
          authTypeKey: 0
        },
        {
          authTypeName: 'X.509证书',
          authTypeKey: 1
        }
      ],
      drawerFlag: false, // 抽屉开关
      status: false
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').focus()
      }
    }
  },
  created() {
    eventBus.$on('resetFields', this.resetFields)
    // 编辑的时候，需要初始化数据
    if (this.operate === 'edit') {
      this.initData()
    }
  },
  watch: {
    tag: {
      handler(val) {
        if (val === 0) {
          console.log('不需要验证')
          this.status = false
        } else {
          this.status = true
        }
      }
    }
  },
  methods: {
    async submitProduct() {
      let validate1 = await this.$refs.addProductDialogStep1.nextStep();
      debugger;
      let validate2 = await this.$refs.addProductDialogStep2.nextStep();
      debugger;
      let validate3 = await this.$refs.addProductDialogStep3.nextStep();
      debugger;
      let validate4 = this.$refs.addProductDialogStep4.nextStep('validate');
      
      // await this.$refs.addProductDialogStep4.nextStep('validate');
      if (validate1 && validate2 && validate3 && validate4) {
        this.$refs.addProductDialogStep4.nextStep();
      } else {
        this.$message.error('输入不完整，请检查')
      }
    },
    submitFinish() {
      this.$emit('closeSteps')
    },
    delImg() {
      // 去重
      let imgArray = [...new Set(this.delImgArr)]
      imgArray = imgArray.filter(item => {
        return item !== ''
      })
      if (imgArray.length === 0) {
        return
      }
      deleteProductFile(imgArray).then(res => {
      }).catch(e => {
      })
      // 清空
      this.delImgArr.splice(0)
    },
    close() {
      // this.tag = 0
      // this.form.productKey = ''
      // this.categoryName = ''
      // this.form.productDescription = ''
      // this.$refs.ruleForm.resetFields()
    },
    initData() {
      const initFormData = {
        productName: this.productDetail.productName, // 产品名称
        productKey: this.productDetail.productKey, // 产品标识
        productModelType: this.productDetail.productModelType, // 产品品类
        categoryParentId: this.productDetail.categoryParentId, // 父级ID
        categoryId: this.productDetail.categoryId, // 子品类id
        nodeType: this.productDetail.nodeType, // 节点类型
        connectionType: this.productDetail.connectionType, // 连网方式
        dataFormat: this.productDetail.dataFormat, // 数据格式
        authType: this.productDetail.authType, // 认证方式
        isPrivate: this.productDetail.isPrivate, // 认证是否私有
        productDescription: this.productDetail.productDescription // 描述
      }
      this.form = initFormData
      console.log('initdata:', this.form)
    },
    resetFields() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    // 提交
    nextStep() {
      // this.$emit('nextStep', 2)
      this.$refs.ruleForm.validate((valid) => {
        if (valid) { // 验证成功
          console.log('productDetail', this.productDetail)
          console.log('form', this.form)
          Object.assign(this.productDetail, this.form)
          if (this.tag === 0) {
            delete this.productDetail.productKey
          }
          console.log('this.productDetail:', this.productDetail)
          this.$emit('nextStep', 2)
        }
      })
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 打开抽屉
    openDrawer(e) {
      this.drawerFlag = true
      this.focusStatus = false
    },
    // 关闭抽屉
    closeDrawer() {
      this.drawerFlag = false
      this.focusStatus = true
    },
    // 获取抽屉传过来的值
    receive(val) {
      console.log('子组件数据', val)
      this.form.categoryId = val.categoryId
      this.form.categoryParentId = val.categoryParentId
      this.categoryName = val.categoryName
      this.drawerFlag = false
      this.focusStatus = true
    }
  },
  components: {
    addProductDialogStep1,
    addProductDialogStep2,
    addProductDialogStep3,
    addProductDialogStep4
  }
}
</script>

<style lang='less' scoped>
.item-row {
  display: flex;
  
  .item-ele {
    flex: 1;
  }
}
</style>
